import { createActionHelpers } from 'vuex-loading'

// export vuex loading helpers
export const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})



// WEBPACK FOOTER //
// ./src/plugins/loading.js